import {
  CREATE_FORM_JSON,
  FormCreationData,
  SELECTED_FORM_ID,
  REMOVE_ELEMENT,
  TRANSFER_ELEMENT_REFERENCE,
  UPDATE_ELEMENT,
  REORDER_ELEMENT_REFERENCE,
  SET_GRID_SELECTION,
  UPDATE_GRID_STYLES,
  SELECTED_DEVICETYPE,
  APIFormData,
  DELETE_BY_VALIDATION_KEY,
  SET_MODAL_VISIBILITY,
  UPDATE_MODAL_CONTENT,
  SET_SNACKBAR_VISIBILITY,
  UPDATE_SELECTED_FORM_ID,
  UPDATE_CANVAS_CONFIG,
  CREATE_ASSET,
  DELETE_ASSET,
  SET_ASSET_EDIT_MODE,
  IAsset,
  IAssets,
  SET_ASSETS,
  DISCARD_ASSET_CHANGES,
  PUSH_FORM_ACTION_STACK,
  UNDO_DELETE_ELEMENT,
  UPDATE_SELECTED_ELEMENTS,
  CLEAR_SELECTED_ITEMS,
  PASTE_COPIED_ELEMENT,
  GROUP_ELEMENTS,
  UN_GROUP_ELEMENTS,
  SELECTED_DEVICE,
  Device,
  UPDATE_V2_FORM_PROPERTIES,
  UPDATE_TAB,
  FIXED_ELEMENTS_ARRAY,
  ADD_COMPUTED_STYLES,
  ADD_CUSTOM_STYLE_URL,
  ADD_WRAPPER_COMPUTED_STYLES,
  COPY_STYLES,
  IS_V3_FORMS,
  DELETE_FIXED_ELEMENT,
  FIXED_ELEMENTS_ARRAY_V3,
  FIXED_ELEMENTS_ARRAY_UPDATE_V3,
  COPY_CANVAS_STYLES,
  UPDATE_TAB_ID,
  APPLY_STYLES
} from "./types";
import { Modal, Snackbar, CanvasConfig } from "./types";

export function addComponentToFormJson(data: FormCreationData) {
  return {
    type: CREATE_FORM_JSON,
    data,
  }
}

export function setSelectedFormItemId(data: {
  id: string;
  isAssetInstanceSelected: boolean;
  shouldSelectGrid?: boolean;
}) {
  return {
    type: SELECTED_FORM_ID,
    data,
  }
}

export function updateSelectedFormItemId(oldId: string, newId: string, increment?: number) {
  return {
    type: UPDATE_SELECTED_FORM_ID,
    data: { oldId, newId, increment }
  }
}

export function updateTabId(oldId: string, newId: string, increment?: number) {
  return {
    type: UPDATE_TAB_ID,
    data: { oldId, newId, increment }
  }
}

export function removeElement(data: {
  id: string;
  parentId?: string;
  type: string;
  selectedElementId?: string
  increment?: number;
}, updateActionPointer: boolean = false) {
  return {
    type: REMOVE_ELEMENT,
    data: { ...data, updateActionPointer },
  }
}

export function transferElementReference(data: {
  id: string,
  dropTargetId: string,
  dragSourceId: string,
  index?: number
}) {
  return {
    type: TRANSFER_ELEMENT_REFERENCE,
    data,
  }
}

export function selectedDeviceType(devicetype: string) {
  return {
    type: SELECTED_DEVICETYPE,
    data: {
        devicetype
      }
  }
}

export function selectedDevice(device: Device) {
  return async function (dispatch: any) {
    dispatch({
      type: SELECTED_DEVICE,
      data: {
        device
      }
    })
  }
}

export function updateElement(data: {
  id: string,
  path: string
  value: string | number | boolean | any[],
}) {
  return {
    type: UPDATE_ELEMENT,
    data,
  }
}

export function updateTab (data:{
  id:string,
  field:string,
  value:string
}){
  return async function (dispatch: any) {
    dispatch({
      type:UPDATE_TAB,
      data
    })
  }
}
export function setFixedElements(data: any){
  return {
    type: FIXED_ELEMENTS_ARRAY,
    data: { fixedArray: data },
  }
}

export function setFixedElementsV3(data: any){
  return {
    type: FIXED_ELEMENTS_ARRAY_V3,
    data: { fixedArray: data },
  }
}

export function setFixedElementsUpdateV3(data: any){
  return {
    type: FIXED_ELEMENTS_ARRAY_UPDATE_V3,
    data: { fixedArray: data },
  }
}

export const deleteFixedElement = (selectedElementId:any) => ({
  type: DELETE_FIXED_ELEMENT,
  data: { selectedElementId },
});

export function reorderElementReference(data: {
  dragSource: { id: string, parentId?: string, index: number },
  dropTarget: { id: string, parentId?: string, index: number },
}) {
  return {
    type: REORDER_ELEMENT_REFERENCE,
    data,
  }
}

export function setGridSelection(data: {
  isGridSelected: boolean
}) {
  return {
    type: SET_GRID_SELECTION,
    data,
  }
}

export function updateGridStyles(data: {
  path: string
  value: string | boolean
}) {
  return {
    type: UPDATE_GRID_STYLES,
    data,
  }
}

export function updateCanvasConfig(data: CanvasConfig) {
  return {
    type: UPDATE_CANVAS_CONFIG,
    data
  }
}

export function deleteByValidationKey(key: string) {
  return {
    type: DELETE_BY_VALIDATION_KEY,
    data: key
  }
}

export const clearFormV2Json = () => {
  return {
    type: 'CLEAR_FORM_V2_JSON'
}
}

export const initializeV2Json = (data: APIFormData) => {
  return {
    type: 'INITIALIZE_FORM_V2_JSON',
    data
  }
}

export const setModalVisibility = (modal: Modal) => {
  return {
    type: SET_MODAL_VISIBILITY,
    data: {
        modal
      }
  }
}

export const updateModalContent = (data: any) => {
  return {
    type: UPDATE_MODAL_CONTENT,
    data,
  }
}

export const setSnackbarVisibility = (snackbar: Snackbar) => {
  return {
    type: SET_SNACKBAR_VISIBILITY,
    data: {
        snackbar
      }
  }
}

export const setAssets = (data: IAssets) => {
  return {
    type: SET_ASSETS,
    data,
  }
}

export const createAsset = (data: {
  id: string
  asset: IAsset
}) => {
  return {
    type: CREATE_ASSET,
    data,
  }
}

export const deleteAsset = (data: {
  id: string
}) => {
  return {
    type: DELETE_ASSET,
    data,
  }
}

export const setAssetEditMode = (data: {
  isEnabled: boolean,
  assetId: string
}) => {
  return {
    type: SET_ASSET_EDIT_MODE,
    data,
  }
}

export const discardAssetChanges = () => {
  return {
    type: DISCARD_ASSET_CHANGES,
}
}

export function redoComponentDropToFormJson(data: FormCreationData) {
  return async function (dispatch: any) {
    dispatch({
      type: CREATE_FORM_JSON,
      data,
    });
  };
}

export function pushFormActionStack(data: { undo: () => void, redo: () => void }) {
  return async function (dispatch: any) {
    dispatch({
      type: PUSH_FORM_ACTION_STACK,
      data,
    });
  };
}

export function undoDeleteElement(data: FormCreationData, order?: string[]) {
  return async function (dispatch: any) {
    dispatch({
      type: UNDO_DELETE_ELEMENT,
      data:{...data, order},
    });
  };
}

export function undoDropElement(data: {
  id: string;
  parentId?: string;
  type: string;
  increment?:number;
}) {
  return async function (dispatch: any) {
    dispatch({
      type: REMOVE_ELEMENT,
      data,
    });
  };
}

export function updateElementOnUndoRedo(data: {id: string; path: string; value: string | number | boolean; increment: number}) {
  return async function (dispatch: any) {
    dispatch({
      type: UPDATE_ELEMENT,
      data,
    });
  };
}

export function reorderUndoElementReference(data: {
  dragSource: { id: string, parentId?: string, index: number },
  dropTarget: { id: string, parentId?: string, index: number },
  increment: number
}) {
  return async function (dispatch: any) {
    dispatch({
      type: REORDER_ELEMENT_REFERENCE,
      data,
    });
  };
}

export function transferUndoRedoElementReference(data: {
  id: string,
  dropTargetId: string,
  dragSourceId: string,
  index?: number,
  increment?: number
}) {
  return async function (dispatch: any) {
    dispatch({
      type: TRANSFER_ELEMENT_REFERENCE,
      data,
    });
  };
}

//  CONTEXT MENU
export function updatedSelectedeElements(id: string) {
  return {
    type: UPDATE_SELECTED_ELEMENTS,
    data: id
  }
}

export function clearSelectedItems() {
  return {
    type: CLEAR_SELECTED_ITEMS,
  }
}

export function pasteCopiedElemenet(data: {
  rootId: string,
  componentOrder: string[],
  components?: {},
  increment?:number
}) {
  return async function (dispatch: any) {
    dispatch({
      type: PASTE_COPIED_ELEMENT,
      data,
    });
  };
}

export function groupElements(data: {
  grid: any
  parentId: string
}) {
  return async function (dispatch: any) {
    dispatch({
      type: GROUP_ELEMENTS,
      data,
    });
  };
}
export function ungroupElements(data: {
  grid: any
  parentId: string
}) {
  return async function (dispatch: any) {
    dispatch({
      type: UN_GROUP_ELEMENTS,
      data,
    });
  };
}

export function updateV2FormProperties(data: any) {
  return async function (dispatch: any) {
    dispatch({
      type: UPDATE_V2_FORM_PROPERTIES,
      data
    })
  }
}

export function isCoreV3Form(data: boolean) {
  return async function (dispatch: any) {
    dispatch({
      type: IS_V3_FORMS,
      data
    })
  }
}
export function addComputedStyles(data: any) {
  return async function (dispatch: any) {
    dispatch({
      type: ADD_COMPUTED_STYLES,
      data
    })
  }
}

export function addWrapperComputedStyles(data: any) {
  return async function (dispatch: any) {
    dispatch({
      type: ADD_WRAPPER_COMPUTED_STYLES,
      data
    })
  }
}
export function addStyleUrl(data: any) {
  return async function (dispatch: any) {
    dispatch({
      type: ADD_CUSTOM_STYLE_URL,
      data
    })
  }
}

export const copyStyles = (componentIds: any, fromDeviceType: any, toDeviceType: any) => ({
  type: COPY_STYLES,
  data: { componentIds, fromDeviceType, toDeviceType },
});

export const copyCanvasStyles = (fromDeviceType: any, toDeviceType: any) => ({
  type: COPY_CANVAS_STYLES,
  data: { fromDeviceType, toDeviceType },
});

export function applyStyles(data: {
  rootId: string,
  componentOrder: string[],
  components?: {},
  increment?:number
}) {
  return async function (dispatch: any) {
    dispatch({
      type: APPLY_STYLES,
      data,
    });
  };
}